import type { ExperimentConfig } from '../@types'

// DEV-35261 launches on US + Non-US.
const paywall = {
	experiment: () => import('@/modules/Paywall/instances/experiments/web_lymph_walk_f_paywall_ba_legs'),
}

const config: ExperimentConfig[] = [
	{
		'activity-female-lymphatic-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-lymphatic-walking&exp=web_lymph_walk_f_paywall_ba_legs~1
			paywall,
		},
		'activity-female-lymphatic-walking-pr': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-lymphatic-walking-pr&exp=web_lymph_walk_f_paywall_ba_legs~1
			paywall,
		},
	},
]

export default config
